import React from 'react';
import Box from '@mui/material/Box';
import { Link, useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Logo from './Logo';

const EXPANDED_WIDTH = 250;
const COLLAPSED_WIDTH = 60;

function AppTitle({ isOpen }) {
    const location = useLocation();
    const isOnChatPage = location.pathname === '/chat-page';

    return (
        <Box 
            sx={{ 
                marginLeft: isOnChatPage ? (isOpen ? `${EXPANDED_WIDTH}px` : `${COLLAPSED_WIDTH}px`) : '0px',
                transition: theme => theme.transitions.create('margin-left', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            }}
        >
            {!isOnChatPage && (
                <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                    <Logo width="100" height="100" style={{ marginRight: '10px' }} />
                    <Typography variant="h4" component="div" sx={{ flexGrow: 1, color: 'text.primary', fontWeight: 400 }}>
                        calmind.ai
                    </Typography>
                </Link>
            )}
        </Box>
    );
}

export default AppTitle;